// Options from legacy api
// Frontend\tmp\src\app\main\components\user-edit-slide-form\user-edit-slide-form.controller.coffee
// API\tmp\app\models\user.rb
export const UserStage = {
  DEPARTED: 'departed',
  FIRST_MONTH: 'first_month',
  FIRST_WEEK: 'first_week',
  INCOMPLETE: 'incomplete',
  INVITED: 'invited',
  LAST_MONTH: 'last_month',
  LAST_WEEK: 'last_week',
  NO_ACTIVITY: 'no_activity',
  OFFBOARDING: 'offboarding',
  PRE_START: 'pre_start',
  PREBOARDING: 'preboarding',
  RAMPING_UP: 'ramping_up',
  REGISTERED: 'registered',
};
